<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.condutor"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-condutor"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-condutor"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-condutor"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-condutor"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>

                <slot
                    name="actions"
                    :usuario="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'nome',
                    label: 'Condutor',
                    name: 'cadastroCidadao.nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'numeroCnh',
                    label: 'CNH',
                    name: 'transportePacienteCondutor.numeroCnh',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'categoria',
                    label: 'Categoria',
                    name: 'cadastroCarteiraHabilitacaoCategoria.letra',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'vencimentoHabilitacao',
                    label: 'Vencimento da habilitação',
                    name: 'transportePacienteCondutor.vencimentoHabilitacao',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacienteCondutor.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                }
            ];
        }
    },
    created() {
        this.repositories = {
            condutor: this.getConectaSusRepository('transportePaciente.condutor')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-condutor-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {
            const bloqueio = () => this.repositories.condutor.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o condutor?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(id) {
            const destroy = () => this.repositories.condutor.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o condutor?',
                destroy,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
}

</script>
